export default __webpack_public_path__ + "static/media/light-mode.fcb3a390.png";